module.exports = __webpack_public_path__ + "static/media/otica-default.70cd4c76.png";